import { ExpandMore, LightbulbOutlined, ScienceOutlined, UploadFileOutlined } from '@mui/icons-material'
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import { alpha } from '@mui/material/styles'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { usePermissions } from '@/features/authorization/contexts/PermissionsContext'
import { useFeatureToggle } from '@/features/featureToggle/contexts/FeatureToggleContext'

import ListItemLink from './ListItemLink'

const EASE_OUT_EXPO = 'cubic-bezier(0.16, 1, 0.3, 1)'

function ExperimentsSection() {
  const { t } = useTranslation()
  const { isEnabled } = useFeatureToggle()
  const { permissions } = usePermissions()
  const [open, setOpen] = useState(false)

  function handleClick() {
    setOpen(!open)
  }

  return (
    <>
      <ListItemButton
        sx={(theme) => ({
          py: 0.5,
          transition: `background-color 160ms ${EASE_OUT_EXPO}, color 160ms ${EASE_OUT_EXPO}`,
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.045),
          },
          '&:hover .ExperimentsSection-icon, &:hover .ExperimentsSection-label, &:hover .ExperimentsSection-chevron': {
            color: theme.palette.text.primary,
          },
        })}
        onClick={handleClick}
      >
        <ListItemIcon
          className="ExperimentsSection-icon"
          sx={(theme) => ({
            color: alpha(theme.palette.text.secondary, 0.7),
            minWidth: 32,
            transition: `color 160ms ${EASE_OUT_EXPO}`,
            '& .MuiSvgIcon-root': { fontSize: '1.25rem' },
          })}
        >
          <ScienceOutlined />
        </ListItemIcon>
        <ListItemText
          primary={t('common.experiments')}
          primaryTypographyProps={{
            className: 'ExperimentsSection-label',
            sx: {
              fontWeight: 500,
              fontSize: '0.8125rem',
              color: 'text.secondary',
              transition: `color 160ms ${EASE_OUT_EXPO}`,
            },
          }}
        />
        <ExpandMore
          className="ExperimentsSection-chevron"
          sx={{
            color: 'text.secondary',
            fontSize: '1.125rem',
            transition: `transform 220ms ${EASE_OUT_EXPO}, color 160ms ${EASE_OUT_EXPO}`,
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
        />
      </ListItemButton>
      <Collapse unmountOnExit in={open} timeout={220}>
        <List disablePadding component="div" sx={{ pl: 1.5, pb: 0.5 }}>
          {permissions.has('bidding') && (
            <ListItemLink
              activePath={'/bidding/import-accepted-bid'}
              icon={<UploadFileOutlined />}
              primary={t('common.import_accepted_bid')}
              to="/bidding/import-accepted-bid"
            />
          )}
          {isEnabled('FLEXPORTAL_EXAMPLE_FEATURE_ENABLED') && permissions.has('exampleFeatures') && (
            <ListItemLink
              activePath={'/example-feature'}
              icon={<LightbulbOutlined />}
              primary={t('common.example_feature')}
              to="/example-feature"
            />
          )}
        </List>
      </Collapse>
    </>
  )
}

export default ExperimentsSection
